import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "components.CamerasPage.title",
    defaultMessage: "Cameras"
  }
});
